import type { TradingOpenOrdersSort } from "@tradingApp/components/Trading/OpenOrders/SortBy";
import type { FrontendOpenOrders } from "hyperliquid";

export function tradingOpenOrdersSort(
  orders: FrontendOpenOrders | null,
  field: TradingOpenOrdersSort["field"],
  dir: "asc" | "desc",
): FrontendOpenOrders {
  if (!Array.isArray(orders)) {
    return [];
  }

  let ordersSorted: FrontendOpenOrders;

  switch (field) {
    case "dateOpened":
      ordersSorted = sortByDateOpened(orders);
      break;
    case "value":
      ordersSorted = sortByValue(orders);
      break;
    default:
      ordersSorted = sortByDateOpened(orders);
  }

  if (dir === "asc") {
    ordersSorted = [...ordersSorted].reverse();
  }

  return ordersSorted;
}

function sortByValue(orders: FrontendOpenOrders): FrontendOpenOrders {
  return [...orders].sort((a, b) => {
    const aLimitPx = Number(a?.limitPx);
    const bLimitPx = Number(b?.limitPx);
    const aSize = Number(a?.sz);
    const bSize = Number(b?.sz);
    const aValue = aLimitPx * aSize;
    const bValue = bLimitPx * bSize;

    return bValue - aValue;
  });
}

function sortByDateOpened(orders: FrontendOpenOrders): FrontendOpenOrders {
  return [...orders].sort((a, b) => {
    const aDateOpened = a?.timestamp;
    const bDateOpened = b?.timestamp;

    return bDateOpened - aDateOpened;
  });
}
